import { i18n } from '@/i18n';
import { SharedRoutes } from '@/shared-routes';
import { backOfficeRoutes } from '@/views/gallery/back-office-routes';
import type { RouteLocation, RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';
import { publicRoutes } from './public-routes';
import { AuthGuard } from '@/auth/auth-guards';

const { t } = i18n.global;

const determineRoutes = (): Array<RouteRecordRaw> => {
  return [
    {
      path: SharedRoutes.LOGOUT,
      component: () => import('./views/logout/Logout.vue'),
    },
    {
      path: SharedRoutes.LOGIN,
      component: () => import('./views/login/Login.vue'),
    },
    {
      path: SharedRoutes.RESET_PASSWORD,
      component: () => import('./views/reset-password/ResetPassword.vue'),
    },
    ...backOfficeRoutes,
    ...publicRoutes,
    {
      meta: { title: t('platform.app.error.403.title') },
      path: SharedRoutes.UNVERIFIED,
      component: () => import(`./views/unauthorized/Unauthorized.vue`),
    },
    {
      meta: { title: t('platform.app.error.403.title') },
      path: SharedRoutes.UNAUTHORIZED,
      component: () => import(`./views/unauthorized/Unauthorized.vue`),
    },
    {
      name: 'NotFound',
      meta: { title: t('platform.app.error.404.title') },
      path: '/:catchAll(.*)*',
      component: () => import(`./views/not-found/NotFound.vue`),
      beforeEnter: (to: RouteLocation) => AuthGuard(to),
    },
  ];
};

const routes = determineRoutes();

const router = createRouter({
  history: createWebHistory(),
  routes,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  scrollBehavior: (_to: RouteLocationNormalized, _from: RouteLocationNormalized, savedPosition: any | null) => {
    const transitionTime = 225; // neon-fade-transition time
    const scrollTo = savedPosition || { left: 0, top: 0 };

    setTimeout(() => {
      window.scrollTo(scrollTo.left, scrollTo.top);
    }, transitionTime);
  },
});

export default router;
